// extracted by mini-css-extract-plugin
export var numberInputContainer = "_84-0";
export var startPickingButton = "_84-1";